import i18n from '../i18n';




export { datify, fmt, ddmmyyyy,
    tomorrow, yesterday,
    is, before, after, beforeEq, afterEq,
    today, sunday, monday,
    future, past,
    beginMonth, beginYear, endMonth, beginDay, endDay,
    nextMonth, prevMonth,
    nextYear, prevYear,
    month, june, july, september,
    monthDuration,
    schoolYear,
    diffTime,
    parse, parseDDMMYYYY, parseYYYYMMDD, parseTime,
    unixts,
    zp
};

export const same = {
    time(one, another) {
        return fmt( one, 'YYYY-MM-DD HH:mm' ) === fmt( another, 'YYYY-MM-DD HH:mm' );
    },

    month(one, another) {
        return fmt( one, 'YYYY-MM' ) === fmt( another, 'YYYY-MM' );
    },

    date(one, another) {
        return is( one, another );
    }
}


let ifn; i18n.then( i => ifn = i );

function datify(value) {
    if ('string' === typeof value && +value)
        return datify( +value );

    if ('number' === typeof value)
        if (value >= 1000000000000)
            // milliseconds
            return new Date( value );
        else 
            // seconds
            return new Date( value * 1000 );

    if ('string' === typeof value)
        try {
            return ~value.indexOf( '-' )
                ? parseYYYYMMDD( value )
                : parseDDMMYYYY( value );
        } catch (ex) {
            try {
                return parseDDMMYYYY( value );
            } catch(ex) {

            }
        }

    return value;
}

function fmt(date, format) {
    date = datify( date );
    if (date instanceof Date)
        return format   
            .replace( 'DofMonthYYYY', '*7*' )
            .replace( 'DofMonthHHmm', '*8*' )
            .replace( 'DofMonYYYY', '*9*' )
            .replace( 'DofMonHHmm', '*10*' )
            .replace( 'DofMonth', '*11*' )
            .replace( 'DofMon', '*12*' )
            .replace( 'YYYY', zp( date.getFullYear(), 4 ) )
            .replace( 'YY', zp( date.getFullYear() % 100 ) )
            .replace( 'Month', '*2*' )
            .replace( 'Mon', '*3*' )
            .replace( 'MM', zp( date.getMonth() + 1 ) )
            .replace( 'M', date.getMonth() + 1 )
            .replace( 'DD', zp( date.getDate() ) )
            .replace( 'D', date.getDate() )
            .replace( 'Sunday', '*4*' )
            .replace( 'Sun', '*5*' )
            .replace( 'SU', '*6*' )
            .replace( 'HH', zp( date.getHours() ) )
            .replace( 'H', date.getHours() + '' )
            .replace( 'mm', zp( date.getMinutes() ) )
            .replace( 'ss', zp( date.getSeconds() ) )
            .replace( '*2*', ifn( ['dates::january', 'dates::february', 'dates::march', 
                'dates::april', 'dates::may', 'dates::june', 
                'dates::july', 'dates::august', 'dates::september', 
                'dates::october', 'dates::november', 'dates::december'][date.getMonth()] ) )
            .replace( '*3*', ifn( ['dates::jan', 'dates::feb', 'dates::mar', 
                'dates::apr', 'dates::may3', 'dates::jun', 
                'dates::jul', 'dates::aug', 'dates::sep', 
                'dates::oct', 'dates::nov', 'dates::dec'][date.getMonth()] ) )
            .replace( '*4*', ifn( ['dates::sunday', 'dates::monday', 'dates::tuesday', 
                'dates::wednesday', 'dates::thursday', 'dates::friday', 'dates::saturday'][date.getDay()] ) )
            .replace( '*5*', ifn( ['dates::sun', 'dates::mon', 'dates::tue', 
                'dates::wed', 'dates::thu', 'dates::fr', 'dates::sa'][date.getDay()] ) )
            .replace( '*6*', ifn( ['dates::su', 'dates::mo', 'dates::tu', 
                'dates::we', 'dates::th', 'dates::fr', 'dates::sa'][date.getDay()] ) )
            .replace( '*11*', ifn( ['dates::DofJanuary', 'dates::DofFebruary', 'dates::DofMarch', 
                'dates::DofApril', 'dates::DofMay', 'dates::DofJune', 
                'dates::DofJuly', 'dates::DofAugust', 'dates::DofSeptember', 
                'dates::DofOctober', 'dates::DofNovember', 'dates::DofDecember'][date.getMonth()],
                { D: date.getDate() } ) )
            .replace( '*12*', ifn( ['dates::DofJan', 'dates::DofFeb', 'dates::DofMar', 
                'dates::DofApr', 'dates::DofMay3', 'dates::DofJun', 
                'dates::DofJul', 'dates::DofAug', 'dates::DofSep', 
                'dates::DofOct', 'dates::DofNov', 'dates::DofDec'][date.getMonth()],
                { D: date.getDate() } ) )
            .replace( '*7*', ifn( ['dates::DofJanuaryYYYY', 'dates::DofFebruaryYYYY', 'dates::DofMarchYYYY', 
                'dates::DofAprilYYYY', 'dates::DofMayYYYY', 'dates::DofJuneYYYY', 
                'dates::DofJulyYYYY', 'dates::DofAugustYYYY', 'dates::DofSeptemberYYYY', 
                'dates::DofOctoberYYYY', 'dates::DofNovemberYYYY', 'dates::DofDecemberYYYY'][date.getMonth()],
                { D: date.getDate(), YYYY: date.getFullYear() } ) )
            .replace( '*9*', ifn( ['dates::DofJanYYYY', 'dates::DofFebYYYY', 'dates::DofMarYYYY', 
                'dates::DofAprYYYY', 'dates::DofMay3YYYY', 'dates::DofJunYYYY', 
                'dates::DofJulYYYY', 'dates::DofAugYYYY', 'dates::DofSepYYYY', 
                'dates::DofOctYYYY', 'dates::DofNovYYYY', 'dates::DofDecYYYY'][date.getMonth()],
                { D: date.getDate(), YYYY: date.getFullYear() } ) )
            .replace( '*8*', ifn( ['dates::DofJanuaryHHmm', 'dates::DofFebruaryHHmm', 'dates::DofMarchHHmm', 
                'dates::DofAprilHHmm', 'dates::DofMayHHmm', 'dates::DofJuneHHmm', 
                'dates::DofJulyHHmm', 'dates::DofAugustHHmm', 'dates::DofSeptemberHHmm', 
                'dates::DofOctoberHHmm', 'dates::DofNovemberHHmm', 'dates::DofDecemberHHmm'][date.getMonth()],
                { D: date.getDate(), HH: zp( date.getHours() ), H: date.getHours() + '', mm: zp( date.getMinutes() ) } ) )
            .replace( '*10*', ifn( ['dates::DofJanHHmm', 'dates::DofFebHHmm', 'dates::DofMarHHmm', 
                'dates::DofAprHHmm', 'dates::DofMay3HHmm', 'dates::DofJunHHmm', 
                'dates::DofJulHHmm', 'dates::DofAugHHmm', 'dates::DofSepHHmm', 
                'dates::DofOctHHmm', 'dates::DofNovHHmm', 'dates::DofDecHHmm'][date.getMonth()],
                { D: date.getDate(), HH: zp( date.getHours() ), H: date.getHours() + '', mm: zp( date.getMinutes() ) } ) )
    }

// DofMonth DofMon 
function ddmmyyyy(date) {
    return fmt( date, 'DD.MM.YYYY' );
}

function parse(dateStr) {
    if ('string' === typeof dateStr)
        return parseYYYYMMDD( dateStr );
    if ('number' === typeof dateStr)
        return new Date( dateStr * 1000 );

    return dateStr;
}

function parseDDMMYYYY(dateStr) {
    const m = dateStr.match( /(\d\d)\.(\d\d)\.(\d\d\d\d)/ ),
        date = parseInt( m[1], 10 ),
        month = parseInt( m[2], 10 ),
        year = parseInt( m[3], 10 );

    const result = new Date();
    // to avoid transforming 01.06 into 01.07 when making it at 31.05 :-)))
    result.setDate( 1 );
    
    result.setFullYear( year );
    result.setMonth( month - 1 )
    result.setDate( date );

    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    result.setMilliseconds(0);

    const timeMatch = dateStr.match( /(\d\d):(\d\d):(\d\d)/ );
    if (timeMatch)
        result.setHours( parseInt( timeMatch[1], 10 ) ),
        result.setMinutes( parseInt( timeMatch[2], 10 ) ),
        result.setSeconds( parseInt( timeMatch[3], 10 ) );

    return result;
}

function parseYYYYMMDD(dateStr) {
    let m = dateStr.match( /(\d\d\d\d)-(\d\d)-(\d\d)/ );
    const date = parseInt( m[3], 10 ),
        month = parseInt( m[2], 10 ),
        year = parseInt( m[1], 10 );

    const result = new Date();
    // to avoid transforming 01.06 into 01.07 when making it at 31.05 :-)))
    result.setDate( 1 );

    result.setFullYear( year );
    result.setMonth( month - 1 )
    result.setDate( date );

    m = dateStr.match( /(\d\d):(\d\d):(\d\d)/ );
    if (m)
        result.setHours( parseInt( m[1], 10 ) ),
        result.setMinutes( parseInt( m[2], 10 ) ),
        result.setSeconds( parseInt( m[3], 10 ) );

    return result;
}

function parseTime(timeStr) {
    return parseYYYYMMDD( `${fmt( today(), 'YYYY-MM-DD' )} ${timeStr}:00` );
}

function tomorrow(date, count = 1) {
    let tomorrow = new Date( date );
    while (count--)
        tomorrow.setDate( tomorrow.getDate() + 1 );
    return tomorrow;
}

function yesterday(date, count = 1) {
    const yesterday = new Date( date );
    while (count--)
        yesterday.setDate( yesterday.getDate() - 1 );
    return yesterday;
}

function zp(value, pad = 2) {
    value += '';
    while (value.length < pad)
        value = '0'+ value;
    return value;
}

function is(one, another) {
    return fmt( one, 'DD.MM.YYYY' ) === fmt( another, 'DD.MM.YYYY' );
}

function before(one, another) {
    return unixts( datify( one ) ) < unixts( datify( another ) );
}

function after(one, another) {
    return unixts( datify( one ) ) > unixts( datify( another ) );
}

function beforeEq(one, another) {
    return unixts( datify( one ) ) <= unixts( datify( another ) );
}

function afterEq(one, another) {
    return unixts( datify( one ) ) >= unixts( datify( another ) );
}

function today() {
    return new Date();
}

function future(date) {
    return fmt( date, 'YYYY-MM-DD' ) > fmt( today(), 'YYYY-MM-DD' );
}

function past(date) {
    return fmt( date, 'YYYY-MM-DD' ) < fmt( today(), 'YYYY-MM-DD' );
}

function monday(day) {
    return 1 === day.getDay();
}

function sunday(day) {
    return 0 === day.getDay();
}

function beginMonth(date) {
    const newDate = new Date( datify( date ) );
    newDate.setDate( 1 );
    return newDate;
}

function endMonth(date) {
    const newDate = new Date( datify( date ) );
    newDate.setDate( monthDuration( date ) );
    return newDate;
}

function beginDay(date) {
    const newDate = new Date( datify( date ) );
    newDate.setHours( 0 );
    newDate.setMinutes( 0 );
    newDate.setSeconds( 0 );
    newDate.setMilliseconds( 0 );
    return newDate;
}

function endDay(date) {
    const newDate = new Date( datify( date ) );
    newDate.setHours( 24 );
    newDate.setMinutes( 0 );
    newDate.setSeconds( 0 );
    newDate.setMilliseconds( 0 );
    return newDate;
}

function beginYear(date) {
    const newDate = new Date( datify( date ) );
    newDate.setMonth( 0 );
    newDate.setDate( 1 );
    return newDate;
}

function month(date) {
    return date.getMonth();
}

function june(date) {
    return 5 === month( date );
}

function july(date) {
    return 6 === month( date );
}

function september(date) {
    return 8 === month( date );
}

function nextMonth(date, count = 1) {
    while (count--) date = nextMonthStep( date );
    return new Date( datify( date ) );
}

function nextMonthStep(date) {
    const newDate = new Date( date );
    const checkDate = beginMonth( date );
    checkDate.setMonth( checkDate.getMonth() + 1 );

    // don't go over month bounds
    if (newDate.getDate() > monthDuration( checkDate ) )
        newDate.setDate( monthDuration( checkDate ) );

    newDate.setMonth( date.getMonth() + 1 );
    return newDate;
}

function prevMonth(date, count = 1) {
    while (count--) date = prevMonthStep( date );
    return date;
}

function prevMonthStep(date) {
    const newDate = new Date( date );
    const checkDate = beginMonth( date );
    checkDate.setMonth( checkDate.getMonth() - 1 );

    // don't go over month bounds
    if (newDate.getDate() > monthDuration( checkDate ) )
        newDate.setDate( monthDuration( checkDate ) );

    newDate.setMonth( date.getMonth() - 1 );
    return newDate;
}

function nextYear(date) {
    const newDate = new Date( datify( date ) );
    newDate.setFullYear( newDate.getFullYear() + 1 );
    return newDate;
}

function prevYear(date) {
    const newDate = new Date( datify( date ) );
    newDate.setFullYear( newDate.getFullYear() - 1 );
    return newDate;
}

function diffTime(timeB, timeA) {
    return minutes( timeB ) - minutes( timeA );
}

function minutes(time) {
    return time.substring(0, 2) * 60 + (time.substring( 3, 5 ) - 0 );
}

function schoolYear(date) {
    // >= september -> current year, < september -> prev year
    if (date.getMonth() < 8) date = prevYear( date );

    return `${fmt( date, 'YYYY' )}/${fmt( nextYear( date ), 'YY' )}`;
}

function unixts(date) {
    if (typeof date === 'number')
        return date;
    else if (typeof date === 'string' && date.length === 10)
        return +date;
        
    return Math.floor( date / 1000 );
}

const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function monthDuration(date) {
    const month = date.getMonth();
    // not feb?
    if (1 != month) return daysInMonth[month];
        
    // leap year
    const year = date.getFullYear();
    return 0 === year%4 && 0 !== year%100 || 0 === year%400 ? 29 : 28;
}



// WEBPACK FOOTER //
// ./src/js/utils/date.js